export function productDetailReportValidate(product_detail_report){
    var result = true;

    if (product_detail_report)
    
    
    return result;
}